import { useEffect } from "react";

const BASE = "VoltNaPřání";

export default function useDocumentTitle(title) {
  useEffect(() => {
    document.title = title ? `${title} | ${BASE}` : `${BASE} | Dovoz elektromobilů ze zahraničí na míru`;
  }, [title]);
}
